<template>
  <b-container fluid>
    <admin-preloader :show="loading"/>
    <admin-breadcrumb name="Pending Applications"/>
    <b-row>
      <b-col cols="12">
        <admin-panel title="Applications" sub-title="Manage all pending applications in GreenLists" with-footer>
          <admin-applications-table :applications="applications"/>
          <template v-slot:footer>
            <b-pagination
                v-model="page"
                :total-rows="total_in_pages"
                :per-page="per_page"
                @change="loadApplications"
                align="center"
                class="admin-pagination mb-0"
            />
          </template>
        </admin-panel>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import AdminPreloader from "../components/AdminPreloader";
import AdminBreadcrumb from "../components/AdminBreadcrumb";
import AdminPanel from "../components/AdminPanel";
import {API_ROUTES} from "../api";
import AdminApplicationsTable from "../components/AdminApplicationsTable";

export default {
  name: "AdminApplications",
  components: {AdminApplicationsTable, AdminPanel, AdminBreadcrumb, AdminPreloader},
  data() {
    return {
      applications: [],
      loading: true,
      page: 1,
      per_page: 10,
      total_in_pages: 0,
    }
  },
  computed: {
    search() {
      return this.$store.state.current.search;
    }
  },
  methods: {
    loadApplications(page = 1) {
      if (!this.loading) {
        this.loading = true;
      }
      let params = {
        page: page,
        per_page: this.per_page
      };
      if (this.search) {
        params['search'] = this.search;
      }
      //Get applications from API
      this.$api.get(API_ROUTES.ADMIN_APPLICATIONS, {
        params: params
      }).then(({data}) => {
        this.applications = data.applications
        this.total_in_pages = data.meta.total;
      }).catch(({response}) => {

      }).finally(() => {
        if (page !== this.page) {
          this.page = page;
        }
        this.loading = false;
      });
    }
  },
  watch: {
    search() {
      this.loadApplications();
    }
  },
  created() {
    this.loadApplications();
  }
}
</script>
